"use strict";

require("core-js/modules/es6.object.define-property.js");

require("core-js/modules/es6.array.index-of.js");

require("core-js/modules/es6.array.is-array.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = addNewValuesOnly;

function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}